export default __webpack_public_path__ + "static/ad-5a5f3d81a3d9016099f029923554107c.svg";